<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl group">
      <inertia-link
        class="flex text-indigo-400 group-hover:text-indigo-600"
        :href="route('shortcuts')"
      >
        <icon name="store-front" class="w-6 mr-3 fill-indigo-400 group-hover:fill-indigo-600" />
        Atalhos /
      </inertia-link>
      <span class="ml-1 font-medium"> Criar </span>
    </h1>
    <form @submit.prevent="store" class="bg-white rounded-md shadow overflow-hidden max-w-3xl p-5">
      <select-input
        v-model="form.page"
        class="pr-6 pb-8 w-full"
        label="Atalho"
        @input="handleInput()"
      >
        <option :value="null" />
        <option v-for="route in availableRoutes" :key="route.id" :value="route.link_page">
          {{ route.link_page }}
        </option>
      </select-input>
      <text-input class="pr-2 pb-8 w-full" label="Rota" v-model="form.url" readonly />
      <div class="flex flex-wrap items-start justify-between gap-4">
        <FileInputBase64
          v-model="form.image"
          class="pr-6 pb-8 w-full"
          accept="image/*"
          label="Ícone"
          :imgEdited="propForInputBase64"
        />
      </div>
      <div>
        <select-input
          v-model="currentRole"
          class="pr-6 pb-8 w-full"
          label="Papéis"
          @input="selectRole"
        >
          <option :value="null" />
          <option v-for="role in localRoles" :key="role.id" :value="role">
            {{ role.name }}
          </option>
        </select-input>
      </div>
      <div class="mb-7">
        <p class="mb-5 font-medium">Papéis selecionados</p>
        <table class="text-justify">
          <tr>
            <th style="min-width: 250px">Nome</th>
            <th style="min-width: 100px"></th>
          </tr>
          <tr v-for="selectedRole in form.rolesList" :key="selectedRole.id">
            <td style="min-width: 250px">
              {{ selectedRole.name }}
            </td>
            <td style="min-width: 100px">
              <button @click="removeRole(selectedRole)" class="remove_btn">Remover</button>
            </td>
          </tr>
        </table>
      </div>
      <loading-button :loading="creating" class="btn-indigo" type="submit">
        Criar atalho
      </loading-button>
    </form>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
import FileInputBase64 from '@/Shared/FIleInputBase64'
import axios from 'axios'

export default {
  metaInfo: { title: 'Criar Atalho' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    FileInputBase64,
    Icon,
  },
  layout: Layout,
  props: {
    availableRoutes: Array,
    roles: Array,
  },
  data() {
    return {
      // form.url: '',
      // form.page: '',
      // currentIcon: '',
      // currentRole: '',
      // currentRouteType: '',
      // rolesList: [],

      creating: false,
      localRoles: [...this.roles],
      // localUsers: [...this.users],

      form: this.$inertia.form({
        page: '',
        url: '',
        image: '',
        rolesList: [],
      }),
      currentRouteType: '',
      currentRole: '',

      propForInputBase64: null,
    }
  },
  methods: {
    handleInput() {
      let currentRouteObj = this.availableRoutes.filter(
        (route) => route.link_page == this.form.page,
      )

      this.form.url = currentRouteObj[0].url + '/' + currentRouteObj[0].flag

      if (currentRouteObj[0].flag !== '-') {
        this.currentRouteType = 'indicators'
      } else {
        this.currentRouteType = 'normal'
      }
    },
    store() {
      this.creating = true

      // let label = this.form.page
      // let url = this.form.url
      // let icon = this.currentIcon
      // let selectedRoles = [...this.rolesList]

      // let routeType = this.currentRouteType

      // console.log(selectedRoles)

      this.form.post(this.route('shortcuts.store').url())

      // axios
      //   .post(this.route('shortcuts.store'), {
      //     _token: this.$page.props.auth.user.csrf_token,
      //     label,
      //     url,
      //     icon,
      //     selectedRoles,
      //     // routeType,
      //   })
      //   .then((response) => {
      //     console.log(response)
      //   })
      //   .catch((error) => {
      //     console.log(error)
      //   })
    },
    selectRole() {
      if (this.currentRole) {
        this.form.rolesList.push(this.currentRole)
        this.localRoles = this.localRoles.filter((role) => role.id !== this.currentRole.id)
        this.currentRole = null
      }
    },
    removeRole(rolesToRemove) {
      this.localRoles.push(rolesToRemove)
      this.form.rolesList = this.form.rolesList.filter((role) => role.id !== rolesToRemove.id)
    },
  },
  mounted() {
    console.log(this.availableRoutes)
    console.log(this.roles)

    this.propForInputBase64 = {
      isBeingEdited: false,
    }
  },
}
</script>

<style scoped>
th,
td {
  padding: 12px;
  border: 1px solid #6c6c6c;
}

.remove_btn:hover {
  color: red;
}
</style>
